import styles from "./styles.module.scss";
import { Loader } from "@common/loader";
import { useSelector } from "react-redux";
import { getPaywallType } from "src/appConfig";

const BODYFAT_MAP = {
  UNDERWEIGHT: "15-18%",
  NORMAL: "19-25%",
  OVERWEIGHT: "26-30%",
  OBESE: "31-40%",
};

const ACTIVITY_LEVEL = {
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  MODERATELY_ACTIVE: "Moderately active",
  HIGHLY_ACTIVE: "Highly active",
};

export const Transform = ({ images, title, header = "With EasyFit" }) => {
  const profile = useSelector((state) => state.user?.userInfo?.fitnessProfile);
  const questions = useSelector((state) => state.user?.userInfo?.questions);

  const isWalky = getPaywallType().toLowerCase().includes("walky");
  const isQuiz =
    getPaywallType() === "QUIZ_PAYWALL" ||
    getPaywallType() === "QUIZ_PAYWALL_V2";
  const showFatPercentage = isQuiz || isWalky;

  const getFilledIndicatorsCount = (level) => {
    switch (level) {
      case "Beginner":
        return 1;
      case "Intermediate":
        return 2;
      case "Moderately active":
        return 3;
      case "Highly active":
        return 3;
      default:
        return 1;
    }
  };

  const getFilledIndicatorsCountDefault = (level) => {
    switch (level) {
      case "beginner":
        return 1;
      case "intermediate":
        return 2;
      case "advanced":
        return 3;
      default:
        return 1;
    }
  };

  if (!profile) {
    return <Loader isWalky={isWalky} />;
  }

  const { bodyMassType, fitnessLevel } = profile;

  const filledCount = isWalky
    ? getFilledIndicatorsCount(ACTIVITY_LEVEL[questions?.qqActivityLevel])
    : getFilledIndicatorsCountDefault(fitnessLevel?.toLowerCase());

  return (
    <div className={styles.container}>
      <div
        className={
          isWalky
            ? styles.transform
            : `${styles.transform} ${styles.defaultBlue}`
        }
      >
        <div className={styles.header}>
          <div className={styles.headerItem}>Now</div>
          <div className={styles.headerDivider}></div>
          <div className={styles.headerItem}>
            <span className={isWalky ? "" : styles.defaultBlue}>{header}</span>
          </div>
        </div>

        <div className={styles.body}>
          <div className={styles.imageWrapper}>
            <img
              src={images[bodyMassType] || images.OBESE}
              alt="Before"
              className={styles.comparisonImage}
            />
            <img
              src={images.After}
              alt="After"
              className={styles.comparisonImage}
            />
          </div>
        </div>
      </div>
      <div
        className={
          isWalky ? styles.cards : `${styles.cards} ${styles.defaultBlue}`
        }
      >
        <div className={styles.cardsWrapper}>
          <div className={styles.metric}>
            <div>
              <p className={styles.title}>Body fat</p>
              {showFatPercentage && (
                <p className={styles.value}>{BODYFAT_MAP[bodyMassType]}</p>
              )}
              <p className={styles.value}>{bodyMassType?.toLowerCase()}</p>
            </div>
          </div>
          <div className={styles.metric}>
            <div>
              <p className={styles.title}>{title} level</p>
              <p className={styles.value}>
                {(isWalky
                  ? ACTIVITY_LEVEL[questions?.qqActivityLevel]
                  : fitnessLevel?.toLowerCase()) || ""}
              </p>
            </div>
            <div className={styles.levelIndicators}>
              {Array.from({ length: 3 }, (_, index) => (
                <div
                  key={index}
                  className={`${styles.indicator} ${
                    index < filledCount ? styles.filled : ""
                  }`}
                ></div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.cardsWrapper}>
          <div className={styles.metric}>
            <div>
              <p className={styles.title}>Body fat</p>
              {showFatPercentage && (
                <p className={styles.value}>{BODYFAT_MAP.NORMAL}</p>
              )}
              <p className={styles.value}>Normal</p>
            </div>
          </div>
          <div className={styles.metric}>
            <div>
              <p className={styles.title}>{title} level</p>
              <p className={styles.value}>Advanced</p>
            </div>
            <div className={styles.levelIndicators}>
              {Array.from({ length: 3 }, (_, index) => (
                <div
                  key={index}
                  className={`${styles.indicator} ${styles.filled}`}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
